<template>
  <div id="modal" class="modal" role="dialog">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
      title="Close"
    > 
      ×
    </button>

    <template v-if="alert">
	    <header class="modal-header">

	    </header>

	    <section class="modal-body">
	      <h4 class="modal-body-title">{{ created_text }}</h4>
	      <p>{{ info_text }}</p>

	      <form class="form form-AlertCreated" action="">
	        <div class="form-group">
	          <label class="form-label" for="org_alert_frequency">Frequency</label>
	          <select class="form-select" name="job_alert_frequency" id="job_alert_frequency" v-model="alert.frequency">
	            <option v-for="freq in frequency" :key="freq" :value="freq">{{ freq }}</option>
	          </select>
	        </div>
	      </form>
	    </section>

	    <footer class="modal-footer">
	      <button class="btn btn-blue-dark" @click="doSave">Save</button>
	    </footer>
    </template>
    <block-spinner :active="spinner" color="text-blue-dark"></block-spinner>

  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'AlertCreated',

    mixins: [AuthMixins],

    props: {
    	payload: {
    		type: Object
    	}
    },

    data() {
      return {
      	alert: false,
        frequency: ['Daily','Weekly','Monthly'],
        spinner: false
      }
    },

    created() {
    	//job-alert-id
    	this.loadJobAlert();
		},

    mounted() {
      // console.log(this.payload);
    },

    methods: {
    	loadJobAlert() {
    		let payload = {'job_alert_id':this.payload.job_alert_id}
	  		return this.$api.loadJobAlert(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {
	        		this.alert = response.data.response;
	        		console.log("alert",this.alert);
	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not load alert.", response);
	      });
    	},
      close() {
        this.$emit('close')
      },
      doSave() {
        this.spinner = true;
      	let payload = {...this.alert, 'job_alert_id':this.payload.job_alert_id};
	  		return this.$api.updateJobAlert(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {
	        		this.$nextTick(() => {
	        			this.updateUser(response.data.enc_user);
	        			this.close();
								this.spinner = false;
                this.emitter.emit('toast', {message:'Created alert successfully', type:'success'});
	        		});
	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not saved alert.", response);
	      });
      },
    },

    computed: {
    	created_text() {
    		if (this.alert) {
    			if (this.alert['org-main-id']) {
    				return 'Alert created'; // We may extend this to say ` for COMPANY-XXX`
    			} else {
    				return 'Alert created';
    			}
    		}
    		return '';
    	},
    	info_text() {
    		if (this.alert) {
    			if (this.alert['org-main-id']) {
    				return 'From now on every time they post we\'ll send you an email. You can cancel at any time.';
    			} else {
    				return 'We\'ll send an email when jobs get posted matching these settings.';
    			}
    		}
    		return '';
    	}
    }
  };
</script>
